import { FC, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { getStripePrices, register, setCurrentStripePrice, setRegisterData } from 'modules/auth/actions';
import { dispatch } from 'store';
import { Button } from 'views/components';
import { RootState } from 'types';

import { InfoBlock } from '../../components/InfoBlock';
import { PrevStep } from '../../components/PrevStep';

import { t } from 'utils';
import styles from './ThirdStep.module.css';
import texts from '../../../texts';

export const ThirdStepCompany: FC = () => {
  const { registerData, stripePrices, errors } = useSelector((state: RootState) => state.auth);
  const { countriesList } = useSelector((state: RootState) => state.user);
  const { currentCountry } = useSelector((state: RootState) => state.app);

  useEffect(() => {
    dispatch(getStripePrices.request());
  }, []);

  useEffect(() => {
    if (!registerData.currentStripePrice && stripePrices.length > 0) {
      dispatch(setCurrentStripePrice(stripePrices[0]));
    }
  }, [stripePrices, registerData]);

  const renderError = () => {
    for (let key in errors) {
      return <p style={{ color: 'red', fontSize: '12px' }}>{errors[key]}</p>;
    }
  };

  const handleSubmit = () => {   
    const findedArr = countriesList.filter(i => i.short_name === currentCountry);
    if(findedArr && findedArr.length) {
     dispatch(setRegisterData('country', `${findedArr[0].id}`));
    }
    dispatch(register.request(true))
};

  return (
    <div className={styles.container}>
      <PrevStep step={3} />

      <div style={{ width: '100%' }}>
        {renderError()}
        <h1>{t(texts.companyThirdStepTitle)}</h1>
        <p>{t(texts.companyThirdStepDesc)}</p>
        <InfoBlock company numberOfMachines={registerData.howManyClinics} />
      </div>

      <div style={{ marginTop: '40px' }}>
        <Button
          title={t(texts.companyThirdStepLooksGood)}
          onClick={handleSubmit}
        />
      </div>
    </div>
  );
};
